import React from 'react';
import { Popover } from 'antd';
import dot from 'dot-object';
import { deepFind } from '../../helpers/deepFind';
import { _checkValue } from '../../helpers/form';
import styled from 'styled-components';
import { formatClassname } from 'datastake-daf/src/helpers/ClassesHelper';
import { propHasValue } from '../../components/DynamicFormNew/helper';

export const inputTypes = {
  MODAL: 'modal',
};

export const isGroupInput = (group, repeatable = false, data) => {
  let resp = group.inputs
    && Object.keys(group.inputs).length
    && group.repeatable === repeatable
    && group.display !== 'group'
    && !group.viewGroup
    && !group.component;
  if (group.showIf) {
    resp = resp && showHideInput(group, data);
  }
  return resp;
}

export const repeatObjects = (obj, fn = () => { }, filter = null) => filter ?
  Object.keys(obj).filter((key) => filter(obj[key])).map(fn) : Object.keys(obj).map(fn);

export const conditions = new RegExp(/( is | and | not | notEmpty | includes )/gm);

export const getLastRow = (arr, cols) => {
  let currentInd = -1;
  const newArr = [];
  arr.forEach(nr => {
    if (nr % cols === 0) {
      newArr[currentInd + 1] = [nr];
      currentInd++;
    } else {
      newArr[currentInd].push(nr);
    }
  });
  return newArr[newArr.length - 1];
}
const _verifyCondition = (condition, data, allData) => {
  let [path, match, needed] = condition.split(conditions);
  const isRepeatable = path.split('./').length > 1;
  path = isRepeatable ? path.split('./')[1] : path;
  match = match ? match.trim() : match;
  if (path) {
    const currentValue = dot.pick(path, isRepeatable ? data : (allData || data));
    if (match === 'notEmpty') {
      return propHasValue(currentValue)
        && currentValue !== '';
    }
    return _checkValue(needed, match, currentValue);
  }
  return false;
}
export const verifyConditional = (condition, data, allData) => {
  if (!condition) {
    return true;
  }
  const isOrCond = condition.indexOf('OR') >= 0;
  const allParts = condition.split(/( OR | && )/gmi).filter(c => !['OR', '&&'].includes(c.trim()));
  const parts = allParts.map(cond => _verifyCondition(cond, data, allData));
  return parts.length > 0 && ((isOrCond && parts.filter(p => p).length >= 1) || parts.filter(p => !p).length === 0);
}
const checkCondition = (condition, formsValue, repeatValues, input) => {
  let [field, match, wantedValue] = condition.split(/( is | includes | not | notEmpty | notOnly )/gmi);
  match = match ? match.trim() : null;
  const isRepeatable = field.split('./').length > 1;
  const isNotEmpty = match === 'notEmpty';
  const formValue = isRepeatable ? repeatValues : formsValue;
  field = isRepeatable ? field.split('./')[1] : field;
  if (match && field.split('.').length > 1) {
    if (input.inputs) {
      const value = deepFind(formValue, field);
      const isShown = _checkValue(
        isNotEmpty ? field : wantedValue,
        match,
        isNotEmpty ? formValue : value
      );
      return isShown;
    } else {
      if ((isRepeatable ? !repeatValues : !formsValue)) {
        return false;
      } else {
        const value = deepFind(formValue, field);
        const isShown = _checkValue(
          isNotEmpty ? field : wantedValue,
          match,
          isNotEmpty ? formValue : value
        );
        return isShown;
      }
    }
  } else {
    const value = deepFind(formValue, field);
    const isShown = _checkValue(
      isNotEmpty ? field : wantedValue,
      match,
      isNotEmpty ? formValue : value
    );
    return isShown;
  }
}

export const showHideInput = (input, formsValue, repeatValues) => {
  if (input.showIf && !input.excludeFromView && !['h2', 'h3', 'h4', 'h5', 'h6'].includes(input.inputType)) {
    const isOrCond = input.showIf.indexOf('OR') >= 0;
    const allParts = input.showIf.split(/( OR | && )/gmi).filter(c => !['OR', '&&'].includes(c.trim()));
    const parts = allParts.map(condition => checkCondition(condition, formsValue, repeatValues, input));
    return parts.length > 0 && ((isOrCond && parts.filter(p => p).length >= 1) || parts.filter(p => !p).length === 0);
  }
  if (typeof input.excludeFromView === 'string') {
    const isOrCond = input.excludeFromView.indexOf('OR') >= 0;
    const allParts = input.excludeFromView.split(/( OR | && )/gmi).filter(c => !['OR', '&&'].includes(c.trim()));
    const parts = allParts.map(condition => checkCondition(condition, formsValue, repeatValues, input));
    const excludeFromView = parts.length > 0 && ((isOrCond && parts.filter(p => p).length >= 1) || parts.filter(p => !p).length === 0);
    return !excludeFromView
  }
  if (input.excludeFromView || ['h2', 'h3', 'h4', 'h5', 'h6'].includes(input.inputType)) {
    return false;
  }
  return true;
}

export const filterInputs = (form, data, repeatValues) => {
  Object.keys(form)
}

export const groupSubsections = (form, onlyConf = false) => {
  return Object.keys(form).reduce((f, fKey) => {
    if (form[fKey].subSection) {
      let subName = form[fKey].subSection;
      if (typeof form[fKey].subSection === "object") {
        subName = form[fKey].subSection.name;
      }
      if (!f[subName]) {
        f[subName] = { label: '', icon: '', position: 0 };
        if (typeof form[fKey].subSection === "object") {
          const { label = '', icon = '', position = 0, showFormIf = '' } = form[fKey].subSection;
          f[subName] = { label, icon, position, showFormIf };
        }
      }
      if (!onlyConf) {
        Object.assign(f[subName], { [fKey]: form[fKey] });
      }
    }
    return f;
  }, {})
}

export const getRiskGradient = (score) => {
  switch (score) {
    case 4:
      return '0:#78C65D 0.33:#FFB546 0.66:#E7783A 1:#CC4426';
    case 3:
      return '0:#78C65D 0.5:#FFB546 1:#E7783A';
    case 2:
      return '0:#78C65D 1:#FFB546';
    case 1:
      return '0:#78C65D 1:#78C65D';
    case 0:
      return '0:#78C65D 1:#ffffff'
    default:
      return '0:#78C65D 0.25:#FFB546 0.5:#E7783A 0.75:#CC4426 1:#B42318';
  }
}

export const stakeholderCategoryOptions = [
  { label: { en: 'Government', fr: 'Gouvernement' }, value: 'government' },
  { label: { en: 'State Security Forces', fr: 'Forces de sécurité étatiques' }, value: 'stateSecurityForces' },
  { label: { en: 'Non-State Armed Group', fr: 'Groupe armé non-étatique' }, value: 'nonStateArmedGroup' },
  { label: { en: 'Business Entity', fr: 'Entité commerciale' }, value: 'corporation' },
  { label: { en: 'Civil Society', fr: 'Société civile' }, value: 'civilSociety' },
  { label: { en: 'Other Organisation', fr: 'Autre Organisation' }, value: 'otherOrganisation' },
  { label: { en: 'Individual', fr: 'Individu' }, value: 'individual' },
  { label: { en: 'Other', fr: 'Autre' }, value: 'other' },
];

export const assessmentConfigs = {
  threat: {
    title: 'Large practice of torture',
    paragraph: "Cases of torture in the workplace and its surroundings affect 10-25% of the workforce.",
  },
  impact: {
    title: 'Stakeholders can fully monitor and mitigate risk',
  },
  vulnerability: {
    title: 'Dangerous impact on human rights standards and working conditions',
    paragraph: "Torture cases by superiors put workers' dignity, security, and health at risk.",
  },
};


export const riskColors = {
  5: '#CF1322',
  4: '#FF4D4F',
  3: '#FA8C16',
  2: '#FADB14',
  1: '#73D13D',
  0: '#f1f1f1',
};
export const getAssesment = (key, subScore, t = (s) => s, maxWidth200 = true, data) => {
  const { label, description } = data ? data[key] : {
    label: null,
  };

  return label ? (
    <SubScoreStyle key={key}>
      <div className="left">
        <p style={{ marginBottom: 0 }}>{t(key)}</p>
        <div className="levels">
          {[...Array(5)].map((level, index) => (
            <div key={index} style={{
              background: (index + 1) <= subScore
                ? riskColors[subScore] : '#f3f3f3'
            }}></div>
          ))}
        </div>
      </div>
      <div className={formatClassname(['right', maxWidth200 && 'max-width-200'])}>
        <h3>{t(label)}</h3>
        {description && (
          <p>{t(description)}</p>
        )}
      </div>
    </SubScoreStyle>
  ) : null;
};

export const InfoPopOverStyle = styled.div`
  max-width: 270px;

  p {
    margin: 0;
    font-size: 12px;
    color: #595959;
    line-height: 18px;
    padding-top: 10px;
  }

  h1 {
    margin: 0;
    font-size: 14px;
    color: #001529;
  }
`;

export const SubScoreStyle = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 10px;

  .left {
    width: 100px;

    p {
      margin: 0;
      margin-bottom: 4px;
      text-align: left;
      width: 100%;
      margin-top: -4px;
      font-size: 13px;
      font-weight: 500;
    }
    
    .levels {
      display: flex;
      justify-content: flex-start;
      height: 15px;

      div {
        width: 15px;
        margin-right: 3px;
        height: 100%;
        background: #f3f3f3;
        &:last-of-type{
          margin-right: 0;
        }
      }
    }
  }

  .right {
    flex: 1;
    &.max-width-200 {
     max-width: 200px;
    }

    h3 {
      font-size: 13px;
      font-weight: 700;
      margin: 0px;
    }

    p {
      font-size: 12px;
      margin: 0px;
    }
  }

`;

export const RiskScorePopover = ({ children, renderPopover, content }) => renderPopover ? (
  <Popover title={null} placement="bottom" content={content}>
    {children}
  </Popover>
) : children;

export const RiskScorePopoverStyle = styled.div`
  display: flex;
  flex-direction: column;

  h2 {
    font-size: 15px;
    font-weight: 500;
    margin: 0px;
    margin-top: 14px;
    margin-bottom: 10px;
  }

  .date {
    margin: 0px;
    color: #595959;
    font-size: 12px;
    font-weight: 500;
  }

  .risk-score {
    display: flex;
    gap: 15px;

    * {
      margin: 0px;
    }

    .info {
      display: flex;
      gap: 15px;

      p {
        font-weight: 400;
        font-size: 14px;
      }

      svg {
        margin-top: 4px;
      }
    }

    .score {
      font-weight: 700;
      color: black;
      font-size: 14px;
    }
  }

  .breakdown { 
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
`;

export const stakeholderSubCategoriesOptions = [
  {
    label: {
      en: 'National Government', fr: 'Gouvernement national',
    },
    value: 'nationalGovernment',
  },
  {
    label: {
      en: 'Local Government', fr: 'Gouvernement local',
    },
    value: 'localGovernment',
  },
  {
    label: {
      en: 'Police', fr: 'Police',
    },
    value: 'police',
  },
  {
    label: {
      en: 'Military', fr: 'Militaires',
    },
    value: 'military',
  },
  {
    label: {
      en: 'Illegal Armed Group / Militia', fr: 'Groupe / milice armé illégal',
    },
    value: 'militia',
  },
  {
    label: {
      en: 'Bandits', fr: 'Bandits',
    },
    value: 'bandits',
  },
  {
    label: {
      en: 'Road Blockers', fr: 'Coupeurs de route',
    },
    value: 'roadBlockers',
  },
  {
    label: {
      en: 'Other', fr: 'Autre',
    },
    value: 'otherNonStateArmedGroup',
  },
  {
    label: {
      en: 'Private limited company',
      fr: 'Société privée à responsabilité limitée',
    },
    value: 'privateCompany',
  },
  {
    label: {
      en: 'Public limited company',
      fr: 'Société anonyme à capital public',
    },
    value: 'publicCompany',
  },
  {
    label: {
      en: 'State-owned company',
      fr: "Société détenue par l'État",
    },
    value: 'stateOwnedCompany',
  },
  {
    label: {
      en: 'Cooperative',
      fr: 'Coopérative',
    },
    value: 'cooperative',
  },
  {
    label: {
      en: 'Sole proprietorship',
      fr: 'Entreprise individuelle',
    },
    value: 'soleProprietorship',
  },
  {
    label: {
      en: 'Statutory corporation',
      fr: 'Corporation statutaire',
    },
    value: 'statutoryCorporation',
  },
  {
    label: {
      en: 'Limited partnership',
      fr: 'Partenariat limité',
    },
    value: 'limitedPartnership',
  },
  {
    label: {
      en: 'General partnership',
      fr: 'Partenariat illimité',
    },
    value: 'unlimitedPartnership',
  },
  {
    label: {
      en: 'Holding company',
      fr: 'Société de portefeuille',
    },
    value: 'holdingCompany',
  },
  {
    label: {
      en: 'Other',
      fr: 'Autre',
    },
    value: 'other',
  },
  {
    label: {
      en: 'Local civil society organisation',
      fr: 'Organisation de la société civile locale',
    },
    value: 'localCivilSocietyOrganisation',
  },
  {
    label: {
      en: 'National civil society organisation',
      fr: 'Organisation de la société civile nationale',
    },
    value: 'nationalCivilSocietyOrganisation',
  },
  {
    label: {
      en: 'International NGO',
      fr: 'ONG internationale',
    },
    value: 'internationalNGO',
  },
  {
    label: {
      en: 'Faith based groups',
      fr: 'Groupe religieux',
    },
    value: 'faithBasedGroups',
  },
  {
    label: {
      en: 'Academics',
      fr: 'Université ou centre de recherche',
    },
    value: 'academics',
  },
  {
    label: {
      en: 'Other',
      fr: 'Autre',
    },
    value: 'otherCivilSociety',
  },
  {
    label: {
      en: 'Unarmed Civilians',
      fr: 'Civils non-armés',
    },
    value: 'unarmedCivilians',
  },
  {
    label: {
      en: 'Armed Civilians',
      fr: 'Civils armés',
    },
    value: 'armedCivilians',
  },
  {
    label: {
      en: 'Women in Particular',
      fr: 'Femmes en particulier',
    },
    value: 'womenInParticular',
  },
  {
    label: {
      en: 'Children in Particular',
      fr: 'Enfants en particulier',
    },
    value: 'childrenInParticular',
  },
  {
    label: {
      en: 'Whole Community',
      fr: 'Communauté dans son ensemble',
    },
    value: 'wholeCommunity',
  },
];
